import { render, staticRenderFns } from "./ModalUpgradePlan.vue?vue&type=template&id=54c7fea2&scoped=true&"
import script from "./ModalUpgradePlan.vue?vue&type=script&lang=js&"
export * from "./ModalUpgradePlan.vue?vue&type=script&lang=js&"
import style0 from "./ModalUpgradePlan.vue?vue&type=style&index=0&id=54c7fea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c7fea2",
  null
  
)

export default component.exports